import type { MouseEvent } from "react";
import { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Fab,
  Popover,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Close from "@mui/icons-material/Close";

const StyledFab = styled(Fab)(({ theme }) => ({
  position: "fixed",
  bottom: theme.spacing(2),
  right: theme.spacing(2),
  zIndex: 9,
}));

export default function MSBriefHelp() {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <StyledFab
        aria-label="Help"
        color="primary"
        onClick={handleClick}
        size="small"
        variant="extended"
        aria-describedby={id}
      >
        <Typography variant="caption" className="px-1">
          Help?
        </Typography>
      </StyledFab>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Card className="help-message">
          <CardContent className="p-0">
            <Box textAlign="center">
              <Box className="header" padding={1}>
                <Typography variant="body1" className="heading">
                  Need Help?
                </Typography>
                <Close
                  className="close"
                  fontSize="small"
                  onClick={handleClose}
                />
              </Box>
              <Box padding={2}>
                <Typography color="text.primary">
                  You can send an email to{" "}
                </Typography>
                <Typography
                  className="email mx-1"
                  component="a"
                  href="mailto:googleadvertising@hyperlocology.com"
                  color="inherit"
                >
                  googleadvertising@hyperlocology.com
                </Typography>
                <Typography color="text.primary">
                  and a Hyperlocologists will get in contact soon.
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Popover>
    </div>
  );
}
